import { LicenseKind, LICENSE_KINDS } from "../types/licenseTypes";

/**
 * В списке (LicenseListDto) и карточке (LicenseDto) API v2 присылает kind строкой,
 * в запросах на создание ждёт числовой LicenseKind. Приводим обе формы к одному виду.
 */
export const getLicenseKind = (
  kind: string | number | null | undefined
): LicenseKind | null => {
  if (kind === null || kind === undefined || kind === "") return null;

  if (typeof kind === "number") {
    return LICENSE_KINDS.some((k) => k.value === kind)
      ? (kind as LicenseKind)
      : null;
  }

  const normalized = kind.trim().toLowerCase();

  if (/^\d+$/.test(normalized)) return getLicenseKind(Number(normalized));

  const byCode = LICENSE_KINDS.find((k) => k.code === normalized);
  if (byCode) return byCode.value;

  // запасные варианты именования на стороне сервера
  if (
    normalized === "regular" ||
    normalized === "time" ||
    normalized === "term"
  )
    return LicenseKind.Temporary;
  if (normalized === "unlimited" || normalized === "permanent")
    return LicenseKind.Perpetual;
  if (normalized === "sessions" || normalized === "concurrent")
    return LicenseKind.Session;

  const byLabel = LICENSE_KINDS.find(
    (k) => k.label.toLowerCase() === normalized
  );
  return byLabel ? byLabel.value : null;
};

export const getLicenseKindLabel = (
  kind: string | number | null | undefined
): string => {
  const value = getLicenseKind(kind);
  if (value === null) return kind ? String(kind) : "—";
  return LICENSE_KINDS.find((k) => k.value === value)!.label;
};

export const isSessionLicense = (
  kind: string | number | null | undefined
): boolean => getLicenseKind(kind) === LicenseKind.Session;

export const isPerpetualLicense = (
  kind: string | number | null | undefined
): boolean => getLicenseKind(kind) === LicenseKind.Perpetual;
